import {
  BRAND_IMG01,
  BRAND_IMG02,
  BRAND_IMG03,
  BRAND_IMG04,
  BRAND_IMG05,
  BRAND_IMG06,
  BRAND_IMG07,
  BRAND_IMG08,
  BRAND_IMG09,
  BRAND_IMG10,

  BRAND_IMG11,
  BRAND_IMG12,
  BRAND_IMG13,
  BRAND_IMG14,
  BRAND_IMG15,
  BRAND_IMG16,
  BRAND_IMG17,
  BRAND_IMG18,
  BRAND_IMG19,
  BRAND_IMG20,

  BRAND_IMG21,
  BRAND_IMG22,
  BRAND_IMG23,
  BRAND_IMG24,
  BRAND_IMG25,
  BRAND_IMG26,
  BRAND_IMG27,
  BRAND_IMG28,
  BRAND_IMG29,
  BRAND_IMG30,

  BRAND_IMG31,
  BRAND_IMG32,
  BRAND_IMG33,
  BRAND_IMG34,
  BRAND_IMG35,
  BRAND_IMG36,
  BRAND_IMG37,
  BRAND_IMG38,
  BRAND_IMG39,
  BRAND_IMG40,

  BRAND_IMG41,
  BRAND_IMG42,
  BRAND_IMG43,
  BRAND_IMG44,
  BRAND_IMG45,
  BRAND_IMG46,
  BRAND_IMG47,
  BRAND_IMG48,
  BRAND_IMG49,
  BRAND_IMG50,

  BRAND_IMG51,
  BRAND_IMG52,
  BRAND_IMG53,
  BRAND_IMG54,
  BRAND_IMG55,
  BRAND_IMG56,
  BRAND_IMG57,
  BRAND_IMG58,
  BRAND_IMG59,
  BRAND_IMG60,

  
} from "../lib/assets";

export const BRAND_LIST = [
  { id: 1, src: BRAND_IMG01 },
  { id: 2, src: BRAND_IMG02 },
  { id: 3, src: BRAND_IMG03 },
  { id: 4, src: BRAND_IMG04 },
  { id: 5, src: BRAND_IMG05 },
  { id: 6, src: BRAND_IMG06 },
  { id: 7, src: BRAND_IMG07 },
  { id: 8, src: BRAND_IMG08 },
  { id: 9, src: BRAND_IMG09 },
  { id: 10, src: BRAND_IMG10 },

  { id: 11, src: BRAND_IMG11 },
  { id: 12, src: BRAND_IMG12 },
  { id: 13, src: BRAND_IMG13 },
  { id: 14, src: BRAND_IMG14 },
  { id: 15, src: BRAND_IMG15 },
  { id: 16, src: BRAND_IMG16 },
  { id: 17, src: BRAND_IMG17 },
  { id: 18, src: BRAND_IMG18 },
  { id: 19, src: BRAND_IMG19 },
  { id: 20, src: BRAND_IMG20 },

  { id: 21, src: BRAND_IMG21 },
  { id: 22, src: BRAND_IMG22 },
  { id: 23, src: BRAND_IMG23 },
  { id: 24, src: BRAND_IMG24 },
  { id: 25, src: BRAND_IMG25 },
  { id: 26, src: BRAND_IMG26 },
  { id: 27, src: BRAND_IMG27 },
  { id: 28, src: BRAND_IMG28 },
  { id: 29, src: BRAND_IMG29 },
  { id: 30, src: BRAND_IMG30 },

  { id: 31, src: BRAND_IMG31 },
  { id: 32, src: BRAND_IMG32 },
  { id: 33, src: BRAND_IMG33 },
  { id: 34, src: BRAND_IMG34 },
  { id: 35, src: BRAND_IMG35 },
  { id: 36, src: BRAND_IMG36 },
  { id: 37, src: BRAND_IMG37 },
  { id: 38, src: BRAND_IMG38 },
  { id: 39, src: BRAND_IMG39 },
  { id: 40, src: BRAND_IMG40 },

  { id: 41, src: BRAND_IMG41 },
  { id: 42, src: BRAND_IMG42 },
  { id: 43, src: BRAND_IMG43 },
  { id: 44, src: BRAND_IMG44 },
  { id: 45, src: BRAND_IMG45 },
  { id: 46, src: BRAND_IMG46 },
  { id: 47, src: BRAND_IMG47 },
  { id: 48, src: BRAND_IMG48 },
  { id: 49, src: BRAND_IMG49 },
  { id: 50, src: BRAND_IMG50 },

  { id: 51, src: BRAND_IMG51 },
  { id: 52, src: BRAND_IMG52 },
  { id: 53, src: BRAND_IMG53 },
  { id: 54, src: BRAND_IMG54 },
  { id: 55, src: BRAND_IMG55 },
  { id: 56, src: BRAND_IMG56 },
  { id: 57, src: BRAND_IMG57 },
  { id: 58, src: BRAND_IMG58 },
  { id: 59, src: BRAND_IMG59 },
  { id: 60, src: BRAND_IMG60 },


];
